import { Component, Injector, OnInit } from '@angular/core';
import { UserInvitationDto } from '@app/management/models/user-invitation-dto';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { UsersService } from '../users-service.service';

@Component({
  selector: 'app-invite-user',
  templateUrl: './invite-user.component.html',
  styleUrls: ['./invite-user.component.less'],
})
export class InviteUserComponent extends BaseComponent implements OnInit {
  user: UserInvitationDto = {
    email: '',
    name: '',
    position: '',
    role: '',
  };
  roles: any[] = [];
  constructor(injector: Injector, private userService: UsersService) {
    super(injector);
  }

  ngOnInit() {
    this.subscriptions.push(
      this.userService
        .getRoles()
        .subscribe((response: any) => (this.roles = response))
    );
  }

  inviteUser() {
    this.subscriptions.push(
      this.userService
        .inviteUser(this.user)
        .subscribe(() => this.router.navigate(['/management']))
    );
  }
}
